import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useEndOfYearProcessing from 'components/EndOfYearProcessing/hooks/use-end-of-year-processing';

const EndOfYearProcessingInfo: React.FC = () => {
  const { t } = useTranslation('EndOfYearProcessing');
  const { values } = useEndOfYearProcessing();

  if (!values.dateTermEnd) return <></>;

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem">
      <Typography variant="caption">
        {t(
          `End of year processing will automatically happen on the date listed in "End of Year Date" at end of day. This process will remove student and/or teacher licenses and any existing classes.`
        )}
      </Typography>
      <Typography variant="body1">
        <strong>
          {t(
            'Please print, export or save any student reporting as it will no longer be accessible once student licensing has been removed.'
          )}
        </strong>
      </Typography>
    </Box>
  );
};

export default EndOfYearProcessingInfo;
